/** Filter terminal / DevTools console by: `[cookie]` */

export function cookieLog(fn: string, phase: "in" | "out" | "debug", payload: unknown): void {
  console.log("[cookie]", fn, phase, payload);
}
